export default __webpack_public_path__ + "static/media/brave_zone_s1.556d6de0.png";